import ArthrosamidFortius from "@/assets/logos/arthrosamid_fortius.png";
import Arthrosamid from "@/assets/logos/arthrosamid_logo.png";
import ArthrosamidCitius from "@/assets/logos/citius_x_arthrosamid_3.png";
import { Brain, Camera, Fish, Flower, Footprints, Zap } from "lucide-react";

type WatchIcon = JSX.Element;

export type WatchDetail = {
	name: string;
	description: string;
	href: WatchHref;
	icon: WatchIcon;
	comingSoon: boolean;
	infoLink?: string;
	logo?: string;
};

export type Watch =
	| "PAIN"
	| "HEELPAIN"
	| "FOOT"
	| "FISHER"
	| "HEADACHE"
	| "PHOTO"
	| "GYNAE"
	| "ARTHROSAMID"
	| "ARTHROSAMID_CITIUS"
	| "ARTHROSAMID_FORTIUS"
	| "SPINE_SHEFFIELD";
export type WatchHref =
	| "pain-watch"
	| "foot-watch"
	| "fisher-watch"
	| "headache-watch"
	| "photo-diary"
	| "gynae-diary"
	| "arthrosamid-diary"
	| "arthrosamid-citius-diary"
	| "arthrosamid-fortius-diary";

export type WatchesT = {
	[key in Watch]: WatchDetail;
};

export const watches: WatchesT = {
	PAIN: {
		name: "Pain Watch",
		description:
			"Pain tracking to improve patient pathways following MSK procedures.",
		icon: <Zap strokeWidth={1.5} size={32} />,
		href: "pain-watch",
		comingSoon: false,
		infoLink: "https://info.patient-watch.com/info/pain",
	},
	FOOT: {
		name: "Foot Watch",
		description:
			"Foot Watch allows people with diabetes to take an active part in monitoring foot health using photos.",
		icon: <Footprints strokeWidth={1.5} size={32} />,
		href: "foot-watch",
		comingSoon: false,
		infoLink: "https://info.patient-watch.com/info/foot",
	},
	FISHER: {
		name: "Fisher Watch",
		description:
			"Fisher Watch enables fishermen and fisherwomen to work safely by tracking their diabetes while on the water.",
		icon: <Fish strokeWidth={1.5} size={32} />,
		href: "fisher-watch",
		comingSoon: true,
	},
	HEADACHE: {
		name: "Headache Watch",
		description:
			"Headache Watch allows people to self-manage their headaches through understanding what triggers headaches and what cures them.",
		icon: <Brain strokeWidth={1.5} size={32} />,
		href: "headache-watch",
		comingSoon: true,
	},
	PHOTO: {
		name: "Photo Diary",
		description: "",
		icon: <Camera strokeWidth={1.5} size={32} />,
		href: "photo-diary",
		comingSoon: true,
	},
	GYNAE: {
		name: "Gynaecological Diary",
		description: "",
		icon: <Flower strokeWidth={1.5} size={32} />,
		href: "gynae-diary",
		comingSoon: false,
	},
	ARTHROSAMID: {
		name: "Arthrosamid Diary",
		description: "",
		icon: <Zap strokeWidth={1.5} size={32} />,
		href: "arthrosamid-diary",
		infoLink: "https://info.patient-watch.com/info/arthrosamid",
		comingSoon: false,
		logo: Arthrosamid,
	},
	ARTHROSAMID_CITIUS: {
		name: "Arthrosamid Citius Diary",
		description: "",
		icon: <Zap strokeWidth={1.5} size={32} />,
		href: "arthrosamid-citius-diary",
		infoLink: "https://info.patient-watch.com/info/arthrosamid-citius",
		comingSoon: false,
		logo: ArthrosamidCitius,
	},
	ARTHROSAMID_FORTIUS: {
		name: "Arthrosamid Fortius Diary",
		description: "",
		icon: <Zap strokeWidth={1.5} size={32} />,
		href: "arthrosamid-fortius-diary",
		infoLink: "https://info.patient-watch.com/info/arthrosamid-fortius",
		comingSoon: false,
		logo: ArthrosamidFortius,
	},
	HEELPAIN: {
		name: "Heel Pain Diary",
		description: "",
		icon: <Zap strokeWidth={1.5} size={32} />,
		infoLink: "https://info.patient-watch.com/heel-pain",
		comingSoon: false,
	},
	SPINE_SHEFFIELD: {
		name: "Spine Sheffield Diary",
		description: "",
		icon: <Zap strokeWidth={1.5} size={32} />,
		infoLink: "https://info.patient-watch.com/sheffield-spine",
		comingSoon: false,
	},
};

export const showDiaryType = (state: string): React.ReactNode => {
	try {
		const watch = watches[state as Watch];
		return (
			<div className="flex gap-2">
				{watch.icon}
				{watch.name}
			</div>
		);
	} catch (e) {
		console.error(e);
		return "";
	}
};
